import { createSaga } from './saga-helpers';

import * as Api from '../api/discussions-api';

const watchGetDiscussions = createSaga({
    type: 'DISCUSSIONS_FETCH',
    fn: Api.fetchDiscussions,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        discussions: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateDiscussion = createSaga({
    type: 'DISCUSSION_CREATE',
    fn: Api.createDiscussion,
    args: action => [action.payload.discussion],
    successPayload: ({ id: discussionId }, action) => ({
        discussionId,
        fragment: action.payload.discussion
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.milestone
    })
});

const watchGetDiscussion = createSaga({
    type: 'DISCUSSION_FETCH',
    fn: Api.fetchDiscussion,
    args: action => [action.payload.discussionId],
    successPayload: discussion => ({ discussion }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        discussionId: action.payload.discussionId
    })
});

const watchUpdateDiscussion = createSaga({
    type: 'DISCUSSION_UPDATE',
    fn: Api.updateDiscussion,
    args: action => [action.payload.discussionId, action.payload.discussionProps],
    successPayload: discussion => ({ discussion })
});

const watchRemoveDiscussion = createSaga({
    type: 'DISCUSSION_REMOVE',
    fn: Api.removeDiscussion,
    args: action => [action.payload.discussionId, action.payload.force],
    successPayload: (response, action) => ({ discussionId: action.payload.discussionId })
});

const watchMuteDiscussion = createSaga({
    type: 'DISCUSSION_MUTE',
    fn: Api.muteDiscussion,
    args: action => [action.payload.discussionId],
    successPayload: (response, action) => ({ discussionId: action.payload.discussionId })
});

const watchUnmuteDiscussion = createSaga({
    type: 'DISCUSSION_UNMUTE',
    fn: Api.unmuteDiscussion,
    args: action => [action.payload.discussionId],
    successPayload: (response, action) => ({ discussionId: action.payload.discussionId })
});

const watchLeaveDiscussion = createSaga({
    type: 'DISCUSSION_LEAVE',
    fn: Api.leaveDiscussion,
    args: action => [action.payload.discussionId],
    successPayload: (response, action) => ({ discussionId: action.payload.discussionId })
});

const watchAddDiscussionMembers = createSaga({
    type: 'DISCUSSION_ADD_MEMBERS',
    fn: Api.addDiscussionMembers,
    args: action => [action.payload.discussionId, action.payload.members],
    successPayload: discussion => ({ discussion })
});

const watchRemoveDiscussionMembers = createSaga({
    type: 'DISCUSSION_REMOVE_MEMBERS',
    fn: Api.removeDiscussionMembers,
    args: action => [action.payload.discussionId, action.payload.members],
    successPayload: discussion => ({ discussion })
});

const watchPinMessage = createSaga({
    type: 'DISCUSSION_PIN_MESSAGE',
    fn: Api.pinMessage,
    args: action => [action.payload.discussionId, action.payload.messageId],
    successPayload: discussion => ({ discussion })
});

export default [watchGetDiscussions, watchCreateDiscussion, watchGetDiscussion, watchUpdateDiscussion, watchRemoveDiscussion, watchMuteDiscussion, watchUnmuteDiscussion, watchLeaveDiscussion, watchAddDiscussionMembers, watchRemoveDiscussionMembers, watchPinMessage];
